<template>
  <div>
    <div
      class="container"
      :style="{ backgroundImage: 'url(' + content.image + ')' }"
      @click="redirect(content.url)"
    >
      <div class="black_blur"></div>
      <div class="content">
        <div class="logo_container">
          <div class="logo"></div>
          <div class="logo_text">酷炫脑</div>
        </div>
        <div>
          <div class="count">{{ content.count }}人读过</div>
          <div class="title">
            {{ content.title }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["content"],
  name: "result_article",
  data() {
    return {
      // imgUrl:'url('+require('./../../../assets/img/test.png')+')',
      // imgUrl:'https://meditation-1256110421.cos.ap-chengdu.myqcloud.com/1525423f381242e189e38a5c01085ddf.jpg',
      // title:'公众号的标题公众号的标题公众号的标题公众号的标题',
      // count:86
    };
  },
  methods: {
    redirect: function (url) {
      window.location.href = url;
    },
  },
};
</script>

<style scoped>
.container {
  margin-bottom: 30px;
  position: relative;
  padding-left: 15px;
  padding-right: 15px;
  height: 3rem;
  border-radius: 10px;
  background-size: 100%;
  background-position: 10% 20%;
  opacity: 0.8;
}

.logo {
  height: 24px;
  width: 24px;
  background-size: 100%;
  background-image: url("./../../../assets/img/logo.png");
}
.logo_container {
  display: flex;
  align-items: center;
}
.logo_text {
  color: white;
  font-size: 12px;
  padding-left: 5px;
  letter-spacing: 1px;
}
.count {
  letter-spacing: 1px;
  font-size: 10px;
  color: white;
}
.title {
  /*background: papayawhip;*/
  /*padding-top: 2px;*/
  /*letter-spacing: 2px;*/
  line-height: 0.6rem;
  font-size: 15px;
  color: white;
}
.black_blur {
  position: absolute;
  /*z-index: 1;*/
  bottom: 0px;
  left: 0;
  width: 100%;
  height: 3rem;
  margin: 0;
  border-radius: 10px;
  /*background: pink;*/
  background-image: linear-gradient(
    to bottom,
    rgba(0, 0, 0, 0) 0%,
    rgba(0, 0, 0, 0.2) 50%,
    rgba(0, 0, 0, 0.6) 100%
  );
}
.content {
  position: relative;
  padding-top: 9px;
  height: 90%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
</style>